import { Card, CardActions, styled, Box } from "@tm/components"

export const OfferCard = styled(Card)({
    width: "216px",
    minWidth: "216x",
    display: "flex",
    flexDirection: "column",
    height: "100%",
})

export const OfferCardPartActions = styled(CardActions)({
    display: "flex",
    justifyContent: "space-between",
    maxWidth: "100%",
    ".add-to-basket": {
        div: {
            ".amount-field": {
                button: {
                    minWidth: "72px",
                    width: "72px",
                },
            },
            ".basketAmountField": {
                maxWidth: "72px",
                input: {
                    width: "50px",
                },
            },
        },
    },
})

export const WideOfferItemErpContainer = styled(Box)({
    position: "relative",
    display: "flex",
    justifyContent: "space-between",
    height: "2em",
    gap: "0.5em",

    // prevent margin right only in this case and keep it the same everywhere else
    ".price__group": {
        marginRight: "0 !important",
    },
})
